export type MokkDocumentTypeOption = {
  type: number;
  label: string;
};

export const MOKK_DOCUMENT_TYPE_OPTIONS: MokkDocumentTypeOption[] = [
  { type: 0, label: 'Ismeretlen irat' },
  { type: 1, label: 'Kérelem' },
  { type: 2, label: 'Hiánypótlási felhívás' },
  { type: 3, label: 'Hiánypótlás' },
  { type: 4, label: 'Kibocsátott FMH' },
  { type: 5, label: 'Visszautasítás' },
  { type: 7, label: 'Ellentmondás' },
  { type: 8, label: 'Elismerés' },
  { type: 9, label: 'Elismerés + Kifogás' },
  { type: 10, label: 'Elismerés + Részben kifogás' },
  { type: 11, label: 'Részleges ellentmondás' },
  { type: 12, label: 'Részleges ellentmondás + Kifogas' },
  { type: 13, label: 'Részleges ellentmondás + Részben kifogás' },
  { type: 14, label: 'Nyilatkozattételre felhívó végzés' },
  { type: 15, label: 'Jogosult nyilatkozata' },
  { type: 16, label: 'Jogerős (végrehajtás kérhető)' },
  { type: 17, label: 'Visszajelentés' },
  { type: 18, label: 'Jogerős (végrehajtás kérhető)' },
  { type: 19, label: 'Jogerős (végrehajtásnak nincs helye)' },
  { type: 20, label: 'Végrehajtási kérelem' },
  { type: 21, label: 'Elutasított végrehajtás' },
  { type: 22, label: 'Végrehajtási lap' },
  { type: 23, label: 'Felfüggesztett végrehajtás' },
  { type: 24, label: 'Polgári per' },
  { type: 25, label: 'Megszüntetve' },
  { type: 26, label: 'Jegyzőkönyv' },
  { type: 27, label: 'Hirdetmény' },
  { type: 28, label: '(csatolt irat)' },
  { type: 29, label: 'Végzés' },
  { type: 30, label: 'Irodai utasítás' },
  { type: 31, label: 'Biztosítási int. kérelem' },
  { type: 32, label: 'Elrendelt biztosítási intézkedés' },
  { type: 33, label: 'Beadvány' },
  { type: 34, label: 'Kiküldött tértivevény' },
  { type: 35, label: 'Ellentmondásos tértivevény' },
  { type: 36, label: 'Át nem vett tértivevény' },
  { type: 37, label: 'Tértivevény' },
  { type: 38, label: 'Kézbesítés visszavonva' },
  { type: 39, label: 'e-Átvételi elismervény (függő)' },
  { type: 40, label: 'e-Átvételi elismervény' },
  { type: 41, label: 'e-Kézbesítés visszavonva' },
  { type: 42, label: 'e-Átvételi elismervény (lejárt)' },
  { type: 43, label: 'e-Átvételi elismervény (függő)' },
  { type: 44, label: 'e-Átvételi elismervény' },
  { type: 45, label: 'e-Kézbesítés visszavonva' },
  { type: 50, label: 'e-Kézbesítés (fikció)' },
  { type: 51, label: 'Feltöltési igazolás' },
  { type: 52, label: 'Feltöltési igazolás' },
  { type: 53, label: 'Letöltési igazolás' },
  { type: 54, label: 'Letöltési igazolás' },
  { type: 55, label: 'Befogadási igazolás' },
  { type: 56, label: 'Meghiúsulási igazolás' },
  { type: 57, label: 'Bejelentkezési nyilatkozat' },
].sort((a, b) => a.label.localeCompare(b.label, 'hu'));
